<template>
  <v-container>
    <div class="pb-4">
      <v-alert
              v-model="loginError"
              dismissible
              outline
              type="error"
      >
        Cannot login. Please check your email and password.
      </v-alert>
    </div>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <h4 class="headline">Welcome to Magicgecko</h4>
            <h4 class="subheading">Enter email and password below to login</h4>
          </v-card-text>
          <v-form ref="form" v-model="valid" class="pa-2">
            <v-text-field
                    browser-autocomplete="email"
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    type="email"
                    required
                    outline
            ></v-text-field>
            <v-text-field
                    browser-autocomplete="password"
                    v-model="password"
                    :rules="passwordRules"
                    label="Password"
                    type="password"
                    required
                    outline
            ></v-text-field>
            <v-btn
                    :disabled="!valid"
                    @click="submit"
            >
              login
            </v-btn>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<script >
  //const API_URL = 'http://192.168.1.117:3000/graphql';
  const API_URL = '/graphql';

  export default {
    name: 'Home',
    created() {
    },
    methods: {
      submit(){
        fetch(API_URL, {
          method: 'POST',
          body: JSON.stringify({"query": `{
                      loginUser(email: "${this.email}", password: "${this.password}")
                    }`
          }),
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => response.json()).then(result => {
          if(result.data.loginUser === "invalid"){
            this.loginError = true;
          } else {
            this.$router.push('/?t=' + result.data.loginUser);
          }
        }).catch(e => { this.showloading = false; });
      },
      saveToSession(){
        sessionStorage.test = "New Test";
        console.log(sessionStorage.test);
      }
    },
    data () {
      return {
        valid: false,
        loginError: false,
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        password: '',
        passwordRules: [
          v => !!v || 'Password is required',
          v => v.length >= 8 || 'Password must be at least 8 characters'
        ],
      }
    },
    components: {
    }
  }
</script>